import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from "@angular/core";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { AppConfig } from "src/app/configs/app.config";
import { AgencyService } from "src/app/core/services/agency.service";

@Component({
  selector: 'app-agency-selection',
  templateUrl: './agency-selection.component.html',
  styleUrls: ['./agency-selection.component.scss']
})
export class AgencySelectionComponent implements OnInit {
  @Output() step_change = new EventEmitter<any>();
  @Input() step_input: any;

  dataSource: MatTableDataSource<any>;
  @ViewChild("agencyPaginator") paginator: MatPaginator;
  @ViewChild("agencyTableSort") sort: MatSort;

  dataSourceAgnSelected: MatTableDataSource<any>;
  @ViewChild("AgnPaginatorSelected") paginatorAgnSelected: MatPaginator;
  @ViewChild("AgnSortSelected") sortAgnSelected: MatSort;

  displayedColumns: string[] = ["checkbox", "name", "id", "state"];
  showSearchInput: boolean = false;
  showSearchInputSelected: boolean = false;
  route: string;
  agencyItemCount: number = 0;

  allAgenies: Array<any> = [];
  selectedAgenies: Array<any> = [];
  agencyCount: number;
  totalAgencyCount: number;
  search_params = {}

  constructor(
    public agencyService: AgencyService,
  ) { }

  ngOnInit(): void {
    this.selectedAgenies = this.step_input.agencies;
    this.route = this.step_input.route;
    this.getAgencies();
  }

  updateTable(tableCount) {
    this.dataSource = new MatTableDataSource(this.allAgenies);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource._updatePaginator(tableCount);
  }

  updateSelectedTable() {
    this.dataSourceAgnSelected = new MatTableDataSource(this.selectedAgenies);
    this.dataSourceAgnSelected.paginator = this.paginatorAgnSelected;
    this.dataSourceAgnSelected.sort = this.sortAgnSelected;
  }

  searchAgency(event) {
    this.search_params['search_term'] = (event.target as HTMLInputElement).value;
    // let params = {};
    // params = {
    //   search_term: filterValue,
    // };
    // if (filterValue.length == 0) {
    //   params = {};
    // }
    this.getAgencies(this.search_params);
    // this.advtdataSource.filter = filterValue.trim().toLowerCase();

    // if (this.advtdataSource.paginator) {
    //   this.advtdataSource.paginator.firstPage();
    // }
  }

  getAgencies(params = {}, merge = false) {
    this.agencyService.list(params).subscribe((res) => {
      if (merge) {
        this.allAgenies = this.allAgenies.concat(res.data);
        this.updateSelectedTable();
        this.updateTable(this.agencyCount);
      } else {
        this.allAgenies = res.data;
        this.updateSelectedTable();
        this.updateTable(this.totalAgencyCount);
        this.agencyCount = this.totalAgencyCount = res.count;
      }
      if (this.selectedAgenies.length > 0) {
        this.selectedAgenies.forEach(adv => {
          this.allAgenies = this.allAgenies.filter(ele => ele.id != adv.id)
        });
        this.agencyCount = params['search_term']? this.allAgenies.length:this.totalAgencyCount - this.selectedAgenies.length;
        this.updateTable(this.agencyCount);
      }
    });
  }

  handlePageEvent(event: PageEvent) {
    this.agencyCount = event.length;
    let requested_page = event.pageSize * (event.pageIndex + 1);
    if (requested_page > this.allAgenies.length) {
      let params = {
        ...this.search_params,
        start_element: event.pageSize >= this.allAgenies.length ? event.pageSize : this.allAgenies.length + this.selectedAgenies.length,

        num_elements: 100,
      };
      this.getAgencies(params, true);
    }
  }

  addAgencies(row) {
    this.selectedAgenies.push(row);
    this.allAgenies = this.allAgenies.filter((deal) => deal.id != row.id);
    this.updateSelectedTable();
    this.agencyCount = this.agencyCount - 1;
    this.updateTable(this.agencyCount);
  }

  removeAgency(row) {
    this.selectedAgenies = this.selectedAgenies.filter((ele) => ele.id != row.id);
    this.allAgenies.unshift(row);
    this.updateSelectedTable();
    this.agencyCount = this.agencyCount + 1;
    this.updateTable(this.agencyCount);
  }

  removeAllAgencies() {
    this.selectedAgenies.forEach(adv => {
      this.removeAgency(adv)
    })
    this.agencyCount = this.totalAgencyCount;
  }

  back() {
    this.step_change.emit({
      agencies: this.selectedAgenies,
      previous: true
    });
  }

  proceed() {
    this.step_change.emit({
      agencies: this.selectedAgenies,
    });
  }

}
